import { RefObject, useCallback, useLayoutEffect, useState } from 'react';

/**
 * Возвращает количество карточек, помещающихся в одну строку,
 * исходя из фактической ширины контейнера и минимальной ширины карточки.
 *
 * @param containerRef   ref на DOM‑элемент с flex/классом grid
 * @param itemMinWidth   минимальная ширина карточки в пикселях (по макету 230 px)
 */
export const useItemsPerRow = (
  containerRef: RefObject<HTMLElement>,
  itemMinWidth = 230,
): number => {
  const [itemsPerRow, setItemsPerRow] = useState(1);

  const recalc = useCallback(() => {
    const el = containerRef.current;
    if (!el) return;
    const { width } = el.getBoundingClientRect();
    // гарантируем минимум 1 карточку
    setItemsPerRow(Math.max(1, Math.floor(width / itemMinWidth)));
  }, [containerRef, itemMinWidth]);

  useLayoutEffect(() => {
    if (typeof ResizeObserver === 'undefined') return;
    recalc();
    if (!containerRef.current) return;
    const ro = new ResizeObserver(recalc);
    ro.observe(containerRef.current);
    return () => ro.disconnect();
  }, [recalc]);

  return itemsPerRow;
};